import React from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';

import { CurrencyConversionRatesPropTypes } from '../../shared/propTypes/currencyConversionRate';
import { currencyConversionRatesImportColDefs } from '../../shared/columnDefinitions/currencyConversionRates';

const CurrencyConversionRatesMissingRates = ({ missingRates, isFetchingCurrencyConversionRates }) =>
  (
    <div className="admin-import-grid page-content-container">
      <div className="ag-theme-bootstrap">
        <AgGrid
          columnDefs={currencyConversionRatesImportColDefs}
          rowData={missingRates}
          withSearchBar
          isGridLoading={isFetchingCurrencyConversionRates}
        />
      </div>
    </div>
  );

CurrencyConversionRatesMissingRates.propTypes = {
  missingRates: CurrencyConversionRatesPropTypes,
  isFetchingCurrencyConversionRates: PropTypes.bool.isRequired,
};

export default CurrencyConversionRatesMissingRates;
